<template>
  <v-card
    width="100%">
    <v-tabs
      v-model="tab"
      center-active
      background-color="grey lighten-2"
      show-arrows>
      <v-tabs-slider color="orange darken-4"></v-tabs-slider>
      <v-tab
        v-for="i,key in navitem.child"
        :key="key">
        <v-badge
          :value="i.isactive"
          color="red">
          <template v-slot:badge>
            <span style="font-size:10px;">hot</span>
          </template>
          <span>{{ i[$store.state.lang+'_name'] }}</span>
        </v-badge>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="i,key in navitem.child"
        :key="key">
        <Navtabsub :pid="i.id" :path="i.path"/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import Navtabsub from '@/components/Navtabsub.vue'

export default{
  components:{
    Navtabsub,
  },
  data(){
    return{
      tab:0,
    }
  },
  props:{
    navitem:{
      type:Object,
    },
  },
}
</script>

<style scoped>

</style>